import React from 'react';
import './App.css';
import img1 from './deliberate.jpeg';
import img2 from './rev.jpeg';
import img3 from './animatrix.jpeg';
import img4 from './realisticvision.jpeg';
import img5 from './ghostmix.jpeg';

function App() {
  return (
    <div className="App">
      <h1>Modelos</h1>
      <div className="flex-container">
        <div className="flex-item">
        <a href="https://civitai.com/models/4823/deliberate"> <img src={img1} alt="deliberate" /></a>
          <h2>Deliberate</h2>
          <a href={"https://huggingface.co/elzen6/modelsfiles/resolve/main/deliberate.ipynb"} download><button className="download-btn">Descargar</button></a>
        </div>
        <div className="flex-item">
        <a href="https://civitai.com/models/7371/rev-animated"> <img src={img2} alt="deliberate" /></a>
          <h2>Rev Animated</h2>
          <a href={"https://huggingface.co/elzen6/modelsfiles/resolve/main/revanimated.ipynb"} download><button className="download-btn">Descargar</button></a>
        </div>
        <div className="flex-item">
        <a href="https://civitai.com/models/21916/animatrix"> <img src={img3} alt="deliberate" /></a>
          <h2>Animatrix</h2>
          <a href={"https://huggingface.co/elzen6/modelsfiles/resolve/main/animatrix.ipynb"} download><button className="download-btn">Descargar</button></a>
        </div>
        <div className="flex-item">
        <a href="https://civitai.com/models/4201?modelVersionId=6987"> <img src={img4} alt="deliberate" /></a>
          <h2>Realistic Vision</h2>
          <a href={"https://huggingface.co/elzen6/modelsfiles/resolve/main/realisticvisionv2.ipynb"} download><button className="download-btn">Descargar</button></a>
        </div>
        <div className="flex-item">
        <a href="https://civitai.com/models/36520/ghostmix"> <img src={img5} alt="deliberate" /></a>
          <h2>Ghost Mix</h2>
          <a href={"https://huggingface.co/elzen6/modelsfiles/resolve/main/Ghostmix.ipynb"} download><button className="download-btn">Descargar</button></a>
        </div>
        {/* aquí van los otros cuatro elementos */}
      </div>
    </div>
  );
}

export default App;